import React from 'react';
import SecondaryTitle from "../../Components/SecondaryTitle";
import Text from "../../Components/Text";

const TaxDetails = (props) => {
    const {
        data = {
            'all_individuals_are_uk_resident':  '',
        },
    } = props;

    return (
        <React.Fragment>
            <SecondaryTitle>Tax information</SecondaryTitle>
            <div className={'row m-0 p-0'}>
                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Are all the individuals on this application resident only in the UK for tax purposes:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.all_individuals_are_uk_resident === 1 ? 'Yes' : 'No'}</Text>
                </div>
            </div>
        </React.Fragment>
    );
}

export default TaxDetails;
